<script setup>
import fengsui1Img from '../../../../assets/images/fengsui1.webp';
</script>

<template>
  <section class="master-section">
    <div class="content-wrapper">
      <div class="image-container">
        <img
          :src="fengsui1Img"
          alt="楓燧大師兄"
          class="master-image"
        />
      </div>
      <div class="text-container">
        <h2 class="title">楓燧大師兄</h2>
        <p class="paragraph">
          <strong>楓燧大師兄</strong>
          ，本名易烊楓燧，是現代道學文化的傳承者與實踐者，活躍於香港及華人地區。
          <strong>研習八字命理、堪輿風水、道教科儀等玄門技藝</strong>
          ，
          <strong>師承龍虎山正一道</strong>
          ，具備正式道脈法脈傳承資格。
        </p>
        <p class="paragraph">
          2023年獲得TVB真人騷節目
          <strong>《通靈之王2》冠軍</strong>
          ，被譽為「最年輕的道教法事導師」。他擅長以現代語境詮釋傳統玄學智慧，推動「道法生活化」，倡導透過修心、佈局與因果之理，改善個人運勢與家庭磁場。
        </p>
        <a
          href="https://diversion.salesmartly.com/split/whatsapp/fi8cxf"
          target="_blank"
          rel="noopener noreferrer"
          class="cta-button"
        >
          立即預約大師兄
        </a>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.master-section {
  width: 100%;
  padding: 20px 40px;
  background: #ffffff;
}

.content-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 60px;
}

.image-container {
  flex: 0 0 auto;
  width: 200px;

  .master-image {
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
  }
}

.text-container {
  flex: 1;

  .title {
    font-size: 15px;
    color: #333333;
    margin-bottom: 10px;
    line-height: 1;
    text-align: center;
  }

  .paragraph {
    font-size: 9px;
    color: rgb(80, 85, 92);
    line-height: 1.8;
    margin-bottom: 10px;
    text-align: center;

    &:last-of-type {
      margin-bottom: 10px;
    }
  }

  .cta-button {
    display: inline-block;
    padding: 8px 70px;
    background: #e5ae40;
    color: #000000;
    font-size: 10px;
    text-decoration: none;
    border-radius: 30px;
    cursor: pointer;
    white-space: nowrap;
  }
}
</style>
